import React, { useState, useEffect } from "react";
import { IconArrowLeft } from "@tabler/icons-react";
import HeadingDetail from "../components/HeadingDetail";
import UserTable from "./UserTable";
import AdvancedConfirmDialog from "components/common/AdvancedConfirmDialog";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const ConferenceDetail = ({
  conference,
  onBack,
  handleOpenEditAdminDialog,
  form,
  setForm,
  filterUsers,
  handleChangeSearchInput,
  handleChangeUnitDropdown,
  handleChangeDepartmentDropdown,
  handleUpdateAccountRole,
}) => {
  const { t: getLabel } = useTranslation();

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [removeItem, setRemoveItem] = useState(null);
  const [isOpenDialogRemoveAdmin, setIsOpenDialogRemoveAdmin] = useState(false);

  const handleAddSelected = user => {
    setSelectedUsers(prev => {
      const isSelected = prev.some(u => u.accountId === user.accountId);
      if (isSelected) {
        return prev.filter(u => u.accountId !== user.accountId);
      } else {
        return [...prev, user];
      }
    });
  };

  const handleRemoveAdmin = removeItem => {
    if (removeItem) setRemoveItem(removeItem);
    setIsOpenDialogRemoveAdmin(true);
  };

  const getRemainAdminAccountIds = () => {
    const originalAdminIds = conference?.adminAccountIds || [];
    const removedAdmins = removeItem ? [removeItem] : selectedUsers;
    return originalAdminIds.filter(adminId => !removedAdmins.some(u => u.accountId === adminId));
  };

  const onConfirmRemove = () => {
    const remainAccountIds = getRemainAdminAccountIds();
    handleUpdateAccountRole({
      serviceId: conference.serviceId,
      accountIds: remainAccountIds,
    });
    setIsOpenDialogRemoveAdmin(false);
    setSelectedUsers([]);
  };

  useEffect(() => {
    setForm(prev => ({ ...prev, state: 1 }));
  }, [conference]);

  useEffect(() => {
    if (!conference?.adminAccountIds) {
      setSelectedUsers([]);
    }
  }, [filterUsers, conference]);

  return (
    <div className="card" style={{ padding: "32px 16px" }}>
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center mb-2">
            <button className="btn btn-icon btn-ghost-secondary" onClick={onBack}>
              <IconArrowLeft size={20} />
            </button>
            <strong style={{ fontSize: 20 }}>{conference.name}</strong>
          </div>
        </div>
        <HeadingDetail
          form={form}
          onChangeSearchInput={handleChangeSearchInput}
          onOpenEditAdminDialog={() => handleOpenEditAdminDialog(conference)}
          onChangeUnitDropdown={handleChangeUnitDropdown}
          onChangeDepartmentDropdown={handleChangeDepartmentDropdown}
          selectedUsers={selectedUsers}
          onRemoveAdmin={handleRemoveAdmin}
        />
        <UserTable
          title={getLabel(LangConstant.TXT_ADMIN_LIST)}
          users={filterUsers.filter(user => conference?.adminAccountIds?.includes(user.accountId))}
          selectedUsers={selectedUsers}
          onSelected={handleAddSelected}
          onActionClick={handleRemoveAdmin}
          actionType="remove"
        />
        <AdvancedConfirmDialog
          open={isOpenDialogRemoveAdmin}
          title={getLabel(LangConstant.TXT_CONFIRM_DELETE_ADMIN_TITLE)}
          content={getLabel(LangConstant.TXT_CONFIRM_DELETE_ADMIN_TEXT)}
          submitProps={{
            submitText: getLabel("L_DELETE"),
            onClick: () => onConfirmRemove(),
          }}
          cancelProps={{
            onClick: () => setIsOpenDialogRemoveAdmin(false),
          }}
        />
      </div>
    </div>
  );
};

export default ConferenceDetail;
